import { memo } from "react";

import { Box, Tooltip } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";

import dayjs from "dayjs";

import {
  CELL_SIZE,
  CELL_GAP,
  WEEK_HEADER_HEIGHT,
} from "../constants/timelineConstants";

function TimelineWeekHeader({ weeks, holidayWeeks }) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        gap: `${CELL_GAP}px`,
        height: WEEK_HEADER_HEIGHT,
        alignItems: "center",
      }}
    >
      {weeks.map((week, index) => {
        const holiday = holidayWeeks[week.format("YYYY-MM-DD")];

        const isCurrentWeek = dayjs().isSame(week, "week");

        return (
          <Tooltip
            key={index}
            title={holiday ? holiday.title : `KW ${week.isoWeek()}`}
          >
            <Box
              sx={{
                width: CELL_SIZE,
                height: CELL_SIZE,

                border: "1px solid",

                borderWidth: isCurrentWeek ? 2 : 1,

                borderColor: "divider",

                bgcolor: holiday
                  ? alpha(theme.palette.levels.lightPurple, 0.5)
                  : isCurrentWeek
                    ? alpha(theme.palette.primary.main, 0.08)
                    : theme.palette.background.paper,

                borderLeft: isCurrentWeek
                  ? `2px solid ${theme.palette.primary.main}`
                  : undefined,
              }}
            />
          </Tooltip>
        );
      })}
    </Box>
  );
}

export default memo(TimelineWeekHeader);
